/**
 * Admin verktøy - KUN FOR UTVIKLING
 * Disse funksjonene skal IKKE brukes i produksjon
 */

import { getDocs, deleteDoc } from 'firebase/firestore';
import { getCompetitionsCollection } from '../services/firestore';

/**
 * Slett ALLE konkurranser (bruk med forsiktighet!)
 */
export const deleteAllCompetitions = async () => {
  try {
    console.log('Fetching all competitions...');
    const competitionsSnapshot = await getDocs(getCompetitionsCollection());
    console.log(`Found ${competitionsSnapshot.docs.length} competitions`);
    
    for (const doc of competitionsSnapshot.docs) {
      const data = doc.data();
      console.log(`Deleting competition: ${data.title} (${doc.id})`);
      await deleteDoc(doc.ref);
    }
    
    console.log('All competitions deleted successfully!');
    alert(`Slettet ${competitionsSnapshot.docs.length} konkurranser`);
  } catch (error) {
    console.error('Error deleting competitions:', error);
    alert('Kunne ikke slette konkurranser: ' + error.message);
  }
};

// Eksporter til window for console-tilgang
if (typeof window !== 'undefined') {
  window.adminTools = {
    deleteAllCompetitions
  };
}
